import script from "./SearchResultProducts.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchResultProducts.vue?vue&type=script&lang=ts&setup=true"

import "./SearchResultProducts.vue?vue&type=style&index=0&id=83a1f31e&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83a1f31e"]])

export default __exports__